import { createContext } from 'react';
import { IGetDishInfoV2, IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';

export interface IAdditionalModalState {
	dishInfo: Nullable<IGetDishInfoV2['data']>;
	IDsSelectedRestaurant: string[];
	selectedAdditionalDishCategory: Nullable<string>;
	selectedAdditionalDishSubCategory: Nullable<string>;
	selectedAdditionalDishes: string[];
	fetchedAdditionalDishes: IItemForGetShortDishInfo[];
}

export const additionalModalInitialState: IAdditionalModalState = {
	dishInfo: null,
	IDsSelectedRestaurant: [],
	selectedAdditionalDishCategory: null,
	selectedAdditionalDishSubCategory: null,
	fetchedAdditionalDishes: [],
	selectedAdditionalDishes: [],
};

export interface IAdditionalModalContext extends IAdditionalModalState {
	setAdditionalDishCategory(value: Nullable<string>): void;
	setAdditionalDishSubCategory(value: Nullable<string>): void;
	setFetchedAdditionalDishes(value: IItemForGetShortInfo[]): void;
	setAdditionalDishes(value: string[]): void;
	removeAdditionalDish(value: string): void;
}

export const AdditionalModalContext = createContext<IAdditionalModalContext>({
	setAdditionalDishCategory: () => undefined,
	setAdditionalDishSubCategory: () => undefined,
	setFetchedAdditionalDishes: () => undefined,
	setAdditionalDishes: () => undefined,
	removeAdditionalDish: () => undefined,
	...additionalModalInitialState,
});
